<div class="{{extraClasses}}">
  <h1 class="heading">{{headingText}}</h1>
  <p class="subtext text-center">{{subText}}</p>
</div>
